import { Icon, IconProps } from "@/base/components/icon/Icon.component";
import IconSvg from "./check.svg?react";

export const CheckIcon = (props: IconProps) => (
  <Icon component={IconSvg} {...props} />
);
